import React from 'react';
import { useMutation } from 'react-query';
import PropTypes from 'prop-types';

import { NotifyModal } from 'components';
import { DIALOG_KINDS } from 'constants/dialogKinds';
import { useSnackbar } from 'hooks';

import { updateBillingContact } from 'api/billingService';

const UpdateContactModal = ({
  toggleModal,
  isLoading,
  isModalOpen,
  updatePrimaryContact,
  tempContact,
  managerPayload,
  setIsLoading,
  setIsModalOpen,
}) => {
  const setSnackbar = useSnackbar();
  const updateBillingContactQuery = useMutation((payload) =>
    updateBillingContact(payload.tempContact, payload.managerPayload),
  );

  const onUpdateContact = () => {
    if (!isLoading) {
      setIsLoading(true);
    }

    updateBillingContactQuery.mutate(
      { tempContact, managerPayload },
      {
        onSuccess: () => {
          setSnackbar({
            message: 'Primary Contact updated successfully.',
            severity: 'success',
          });
          updatePrimaryContact(tempContact);
        },
        onError: () => {
          setIsLoading(false);
          setIsModalOpen(false);
          setSnackbar({
            message:
              'An error occurred while updating the primary contact, please try again later.',
            severity: 'error',
          });
        },
      },
    );
  };

  return (
    <NotifyModal
      title="Confirm"
      confirmText="Yes"
      cancelText="No"
      onCancel={toggleModal}
      onConfirm={onUpdateContact}
      mode={DIALOG_KINDS.INFO}
      isLoading={isLoading}
      open={isModalOpen}
    >
      <div
        className="m-notify-modal"
        data-testid="PlatformAdminUI-AccountInfo-CompanyInfo-UpdateContactModel-Header"
      >
        Are you sure you want to update the primary contact?
      </div>
      <div
        className="m-notify-modal m-notify-modal__main--bold"
        data-testid="PlatformAdminUI-AccountInfo-CompanyInfo-UpdateContactModel-Body"
      >
        Note: This will change which email your bill gets sent to.
      </div>
    </NotifyModal>
  );
};

UpdateContactModal.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  managerPayload: PropTypes.object.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  tempContact: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  updatePrimaryContact: PropTypes.func.isRequired,
};

export default UpdateContactModal;
